module.exports = __webpack_public_path__ + "static/media/slideshow-51.a2331f0f.jpeg";